import { Component, ViewChild } from '@angular/core';

@Component({
    selector: 'app-technician-dashboard',
    template:`
    <simple-header class="padding-8" title="Dashboard" [back]="true" icon="close"></simple-header>
    <div class="container" #container>
        <router-outlet></router-outlet>
    </div>
    <app-bottom-navigation [buttons]="buttons"></app-bottom-navigation>`,
    styleUrls: ['./technician-dashboard.component.css']
})
export class TechnicianDashboardComponent {
  buttons = [
    {
      icon:'build',
      text: 'Mantenimientos',
      url:'/app/dashboard/maintenances',
    },
    {
      icon:'extension',
      text: 'Materiales',
      url:'/app/dashboard/materials',
    },
    {
      icon:'wb_incandescent',
      text: 'Expansiones',
      url:'/app/dashboard/expansions',
    },
    {
      icon:'refresh',
      text: 'Modernizaciones',
      url:'/app/dashboard/modernizations',
    }
  ]
}
